module.exports = __webpack_public_path__ + "static/media/check_outline_large.3b0cff3b.svg";